import LanguageValueObj from "./LanguageValueObj";

export default class GenericLangValueList {
  constructor(name, initialValue=[], namespace) {
    this.namespace=namespace;
    this.name=name;
    this.languageValueList=[];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getList() {
    return this.languageValueList;
  }

  addLanguageValue(lang, value) {
    const obj=new LanguageValueObj();
    obj.setValue(lang, value);
    this.languageValueList.push(obj);
  }

  addNewItem(lang) {
    const obj=new LanguageValueObj();
    obj.setValue(lang, "");
    for (let i=0; i<this.languageValueList.length; i++) {
      const val=this.languageValueList[i].getValue(lang);
      if (this.languageValueList[i].containsLang(lang) && val==="") {
        return false;
      }
    }
    this.languageValueList.push(obj);
    return true;
  }

  removeItem(index) {
    if (index>=this.languageValueList.length||index<0) {
      return;
    }
    this.languageValueList.splice(index, 1);
  }

  removeItemOfLang(index, lang) {
    if (index<0) {
      return;
    }
    let langIndex=0;
    let foundMatch=false;
    for (let iterIndex=0; iterIndex<this.languageValueList.length; iterIndex++) {
      const item=this.languageValueList[iterIndex];
      if (item.containsLang(lang)) {
        langIndex+=1;
        foundMatch=true;
      }
      if ((langIndex-1)===index && foundMatch) {
        this.languageValueList.splice(iterIndex, 1);
        return;
      }
      foundMatch=false;
    }
  }

  parseInputJSON(inputJSON) {
    if (!inputJSON||!inputJSON[this.namespace]) {
      return;
    }
    const obj=inputJSON[this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value=entry[1];
        const v=new LanguageValueObj();
        v.parseJsonObj(value);
        this.languageValueList.push(v);
      }
    } else {
      const v=new LanguageValueObj();
      v.parseInputJSON(inputJSON, this.namespace);
      this.languageValueList.push(v);
    }
  }

  print() {
    for (let i=0; i<this.languageValueList.length; i++) {
      this.languageValueList[i].print();
    }
  }

  getExpandedFormatValue() {
    const expandedList=[];
    for (let index=0; index<this.languageValueList.length; index++) {
      const item=this.languageValueList[index];
      expandedList.push(item.getExpandedFormatValue());
    }
    const obj2ret=[];
    expandedList.map((arrayItem, arrayIndex)=>{
      for (let index=0; index<arrayItem.length; index++) {
        obj2ret.push(arrayItem[index]);
      }
    });
    return obj2ret;
  }

  isEmpty() {
    let condition=true;
    for (let index=0; index<this.languageValueList.length; index++) {
      const item=this.languageValueList[index];
      condition=condition&&item.isEmpty();
    }
    return condition;
  }
}
